import * as React from "react";
import ProductTable from '../components/Product.Table.Container';

const ProductList = (props) => (
  <ProductTable {...props} />
);

export default ProductList;